import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as planUtils from '../../../shared/plan/planUtils';
import { isMonthlyPlan } from '../../../shared/utils/planUtils';
var CurrentPlanComponent = /** @class */ (function () {
    function CurrentPlanComponent(router) {
        this.router = router;
        this.isTrial = true;
        this.planRemainingTime = '';
        this.addonsAvailable = false;
        this.subscriptionExpired = false;
    }
    CurrentPlanComponent.prototype.ngOnInit = function () {
        this.isTrial = this.subscription ? this.subscription.status === 'TRIAL' : true;
        this.planRemainingTime = planUtils.formatPlanRemainingTime(this.subscription);
        this.subscriptionExpired = planUtils.subscriptionExpired(this.subscription);
    };
    CurrentPlanComponent.prototype.changePlan = function () {
        this.router.navigate(['choose-plan']);
    };
    Object.defineProperty(CurrentPlanComponent.prototype, "totalPrice", {
        get: function () {
            if (!this.subscription || !this.subscription.licenses || !this.subscription.licenses.length) {
                return 0;
            }
            var subscriptionLicense = this.subscription.licenses[0];
            var addonLicenses = this.subscription.addonLicenses;
            var planPrice = subscriptionLicense.planPriceCents;
            var addonPrice = addonLicenses && addonLicenses.length ? addonLicenses[0].priceCents : 0;
            var planTotalPriceForPeriod = planPrice / 100;
            var addonTotalPriceForPeriod = addonPrice / 100;
            return planTotalPriceForPeriod + addonTotalPriceForPeriod;
        },
        enumerable: true,
        configurable: true
    });
    CurrentPlanComponent.prototype.currentSubscriptionPrice = function () {
        if (!this.subscription) {
            return 0;
        }
        var currentPlan = this.subscription.licenses[0];
        var interval = currentPlan.interval, planPriceCents = currentPlan.planPriceCents;
        var planPriceDollars = planPriceCents / 100;
        return isMonthlyPlan(interval) ? planPriceDollars : Math.round(planPriceDollars / 12);
    };
    return CurrentPlanComponent;
}());
export { CurrentPlanComponent };
